import { render, staticRenderFns } from "./paymentMethods.vue?vue&type=template&id=f6284edc"
import script from "./paymentMethods.vue?vue&type=script&lang=js"
export * from "./paymentMethods.vue?vue&type=script&lang=js"
import style0 from "./paymentMethods.vue?vue&type=style&index=0&id=f6284edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports